export default __webpack_public_path__ + "ModDemo.d1b346bb.mov";